export default "__VITE_ASSET__DLXfdgEo__"